import { formatDistanceToNow, parseISO, format } from 'date-fns';

export const formatDate = (dateString) => {
  if (!dateString) return 'Invalid date'; // If the date is invalid

  try {
    const date = parseISO(dateString);  // Convert ISO string to Date object
    const now = new Date();
    
    // If the date is within the last 30 days, return relative time
    if (now - date <= 30 * 24 * 60 * 60 * 1000) {
      return formatDistanceToNow(date, { addSuffix: true }); // Relative time format
    }
    
    // If older than a month, return a traditional date format (e.g., Jan 31, 2022)
    return format(date, 'MMM dd, yyyy'); // Custom format: "Jan 31, 2022"
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid date'; // Return fallback in case of an error
  }
};
